"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sso = require("@caddigital/sok-reducers/lib/actions/sso");
var Types = require("types");
var translate_1 = require("utils/translate");
var MaintaenanceBanner_1 = require("components/MaintaenanceBanner");
var sok_ui_1 = require("@caddigital/sok-ui");
var cookies_1 = require("utils/cookies");
require("./style.scss");
var mapStateToProps = function (store) { return ({
    sso: store.sso
}); };
var mapDispatchToProps = function (dispatch) { return ({
    verify: function (x) { return dispatch(sso.verifyRequest(x)); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.verify(this.props.match.params.provider);
    },
    componentDidUpdate: function (prevProps) {
        var _this = this;
        if (this.props.sso.verifyStatus !== prevProps.sso.verifyStatus &&
            (this.props.sso.verifyStatus === 'FETCHED' ||
                this.props.sso.verifyStatus === 'FAILURE')) {
            this.props.sso.verify.foldL(function () {
                _this.props.history.push("/".concat((0, translate_1.getLanguage)(), "/sso"));
            }, function (ss) {
                (0, cookies_1.setCookie)('client_id', ss.clientId, 24 * 30);
                (0, cookies_1.setCookie)('client_domain', ss.clientDomain, 24 * 30);
                (0, cookies_1.setCookie)('federated_user', 'true', 24 * 30);
                var params = {
                    identity_provider: ss.provider,
                    redirect_uri: "".concat(__SSO_REDIRECT__, "/authorizing"),
                    response_type: 'code',
                    client_id: ss.clientId,
                    scope: 'openid',
                    state: "".concat(ss.provider, "-").concat(~~(Math.random() * 1000))
                };
                var search = Object.entries(params)
                    .map(function (_a) {
                    var k = _a[0], v = _a[1];
                    return "".concat(k, "=").concat(encodeURIComponent(v));
                })
                    .join('&');
                window.location.href = "https://".concat(ss.clientDomain, ".auth.eu-west-1.amazoncognito.com/oauth2/authorize?").concat(search);
            });
        }
    }
}), recompose_1.pure);
var component = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(MaintaenanceBanner_1.default, null),
        React.createElement("div", { className: 'sso-redirect' },
            React.createElement("div", null,
                React.createElement(sok_ui_1.LoadingSpinner, null)),
            React.createElement("div", null, (0, translation_1.getLocalization)('sso/redirect/pleaseWait')))));
};
exports.default = enhance(component);
